import React from 'react'
import './Promo.css'

const Promo = () => <div className="prices_promo" />

export default Promo
